
export function loginRedirectCall() {
  let path = window.location.protocol + "//" + window.location.host + "/foodforgood/donor/sign-in"
  //    window.open(path,'mywindow').focus()
  window.location.href = path;
}
  
export function homeRedirectCall() {
  let path = window.location.protocol + "//" + window.location.host + "/foodforgood/donor/"
  //    window.open(path,'mywindow').focus()
  window.location.href = path;
}

export function logOutRedirectCall() {
  localStorage.removeItem("isDonorAdminLogin");
  localStorage.removeItem("DAData");
  localStorage.removeItem("DAid");
  localStorage.removeItem("DAtoken");
  localStorage.removeItem("DAname");
  localStorage.removeItem("DAemail");
  loginRedirectCall()
}

export function loginRedirectCallWithDataStore(data) {
localStorage.setItem("isDonorAdminLogin", "true");
  localStorage.setItem("DAData", JSON.stringify(data));
  localStorage.setItem("DAid", data.id);
  localStorage.setItem("DAtoken", data.token);
  localStorage.setItem("DAname", data.full_name);
  localStorage.setItem("DAemail", data.email);
  homeRedirectCall()
}


